import { Avatar } from '@/components';
import { useMeQuery } from '@/store/people/people.store';

import s from '../subscription.module.scss';

export function UserBadge() {
  const { data: user } = useMeQuery();

  if (!user) return null;

  const { firstName, lastName } = user.personInfo;

  return (
    <div className={s.userBadge}>
      <Avatar firstName={firstName} lastName={lastName} size={36} />
      <span className={s.userName}>{`${firstName} ${lastName}`.trim()}</span>
    </div>
  );
}
